import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { useTenant } from '../../contexts/TenantContext';

const PortalWrapper = ({ children }) => {
  const { slug } = useParams();
  const { company, loading, error, loadCompanyById, loadCompanyBySlug } = useTenant();

  useEffect(() => {
    if (!slug || company?.company_id === slug || company?.slug === slug) return;

    if (slug.startsWith('company_')) {
      loadCompanyById(slug).catch(() => {});
    } else {
      loadCompanyBySlug(slug).catch(() => {});
    }
  }, [slug, company, loadCompanyById, loadCompanyBySlug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-cyan-400" />
      </div>
    );
  }

  if (error) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PortalWrapper;
